// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"v9-z","disabled":"w9-z","label":"x9-z"};